<template>
  <b-row class="text-base no-data-position m-0">
    <b-col class="text-center">
      <div class="text-12"><span>Não há dados para apresentar</span></div>
    </b-col>
  </b-row>
</template>

<script>
export default {

}
</script>

<style>
  .no-data-position {
    position: absolute;
    top: 54%;
    left: 0%;
    transform: translateY(-50%);
    text-align: center;
    width: 100%;
  }
</style>
